import React from "react";
import PropTypes from "prop-types";
import Seat from "../Seat";
import "./style.css";

const SeatComposition = ({ amount, filledAmount, restFillType }) => (
  <div className="seatcomposition">
    {Array(amount)
      .fill()
      .map((zetel, index) => (
        <Seat
          key={`zetel-${index}`}
          fill={index < filledAmount ? "active" : restFillType}
        />
      ))}
  </div>
);

SeatComposition.propTypes = {
  amount: PropTypes.number.isRequired,
  filledAmount: PropTypes.number,
  restFillType: PropTypes.oneOf(["empty", "filled", "active"])
};

SeatComposition.defaultProps = {
  filledAmount: 0,
  restFillType: "empty"
};

export default SeatComposition;



// WEBPACK FOOTER //
// ./src/components/SeatComposition/index.js